import { render } from "./slide15.vue?vue&type=template&id=3cf779ca&scoped=true"
import script from "./slide15.vue?vue&type=script&lang=js"
export * from "./slide15.vue?vue&type=script&lang=js"

import "./slide15.vue?vue&type=style&index=0&id=3cf779ca&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cf779ca"]])

export default __exports__